export default {
      id: "notification-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "mysource_files/sprite-map.svg#notification",
      toString: function () {
        return this.url;
      }
    }